import { render, staticRenderFns } from "./SuperAdminConfigurationCopyStakeAiStreamer.vue?vue&type=template&id=404fe7c4&lang=pug"
import script from "./SuperAdminConfigurationCopyStakeAiStreamer.vue?vue&type=script&lang=ts"
export * from "./SuperAdminConfigurationCopyStakeAiStreamer.vue?vue&type=script&lang=ts"
import style0 from "./SuperAdminConfigurationCopyStakeAiStreamer.vue?vue&type=style&index=0&id=404fe7c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCol,VForm,VIcon,VRow,VSwitch,VTextField})
